import _Object$keys from 'babel-runtime/core-js/object/keys';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { Tracker } from '../Tracker';
import { SAFER_GAMBLING_EVENT_NAME, PROFIT_LOSS_EVENT_NAME } from './constants';

var TILES_LABELS = {
  ProfitAndLossTile: 'Profit and Loss Summary',
  SelfAssessmentTile: 'Self Assessment',
  selfAssessment: 'Self Assessment',
  DepositLimitsTile: 'Deposit Limits',
  depositLimitsPage: 'Deposit Limits',
  GamingTimeReminderTile: 'Time Reminders',
  AccountClosureTile: 'Account Closure',
  TimeOutTile: 'Time Out',
  timeOut: 'Time Out',
  SelfExclusionTile: 'Self Exclusion'
};

var PAYLOAD_LABELS = {
  profit: 'Profit',
  loss: 'Loss'
};

export var TilesTracker = function (_Tracker) {
  _inherits(TilesTracker, _Tracker);

  function TilesTracker() {
    _classCallCheck(this, TilesTracker);

    return _possibleConstructorReturn(this, (TilesTracker.__proto__ || _Object$getPrototypeOf(TilesTracker)).apply(this, arguments));
  }

  _createClass(TilesTracker, [{
    key: 'tileClicked',
    value: function tileClicked(id) {
      this.publishPartialEvent(SAFER_GAMBLING_EVENT_NAME, {
        SiteSectionCategory: 'Category Selection',
        EventAction: 'Category Selection',
        EventLabel: TILES_LABELS[id] || id,
        ElementType: 'Spitfire'
      });
    }
  }, {
    key: 'profitLossTileClicked',
    value: function profitLossTileClicked(id, payload) {
      var eventData = {
        SiteSectionCategory: 'Category Selection',
        EventAction: 'My Transactions',
        EventLabel: TILES_LABELS[id] || id,
        ElementType: 'Safer Gambling Menu',
        DateRangeType: 'Month to date'
      };
      if (payload) {
        var keys = _Object$keys(payload);
        keys.forEach(function (key) {
          eventData[key] = PAYLOAD_LABELS[payload[key]] || payload[key];
        });
      }
      this.publishPartialEvent(PROFIT_LOSS_EVENT_NAME, eventData);
    }
  }]);

  return TilesTracker;
}(Tracker);